import produce from 'immer';
import { put, takeLatest } from 'redux-saga/effects';
import axios from 'utils/axios';
import { creator, errorMessageGenerator } from 'uwork-app-core';

/**
 * External Ations
 */

/**
 * Constants
 */
export const REQUEST = '@app/workers/orders/notify/channel/renotify/REQUEST';
export const SUCCESS = '@app/workers/orders/notify/channel/renotify/SUCCESS';
export const FAILURE = '@app/workers/orders/notify/channel/renotify/FAILURE';
export const CLEAR = '@app/workers/orders/notify/channel/renotify/CLEAR';

/**
 * Initial state
 */
const initState = {
    loading: false,
    error: '',
    success: false,
    channel: ''
};

/**
 * Defualt reducer
 *
 * @param state
 * @param action
 */
const reducer = (state = initState, { payload, ...action }) =>
    produce(state, (draft) => {
        switch (action.type) {
            case SUCCESS:
                draft.success = true;
                draft.loading = false;
                draft.channel = payload;
                break;
            case FAILURE:
                draft.error = payload;
                draft.loading = false;
                break;
            case REQUEST:
                draft.loading = true;
                draft.success = false;
                draft.error = '';
                draft.channel = '';
                break;
            case CLEAR:
                draft.loading = false;
                draft.success = false;
                draft.error = '';
                draft.channel = '';
                break;
            default:
                break;
        }
    });
export default reducer;

/**
 * Redux actions
 */
export const actions = {
    request: (data) => creator(REQUEST, data),
    success: (data) => creator(SUCCESS, data),
    failure: (data) => creator(FAILURE, data),
    clear: () => creator(CLEAR)
};

/**
 * Sagas
 */
export const sagas = {
    *request({ payload }) {
        try {
            const { order_id, channel } = payload;
            yield axios.post(`/orders/renotify/${order_id}`, { channel });
            yield put(actions.success(channel));
        } catch (e) {
            console.error(e);
            const error = errorMessageGenerator(e);
            yield put(actions.failure(error));
        }
    }
};

/**
 * Saga watchers
 */
export const watcher = function* watch() {
    yield takeLatest(REQUEST, sagas.request);
};
